export default {
    GET_PROVIDER_DETAILS_REQUEST: "GET_PROVIDER_DETAILS_REQUEST",
    GET_PROVIDER_DETAILS_SUCCESS: "GET_PROVIDER_DETAILS_SUCCESS",
    GET_PROVIDER_DETAILS_FAILURE: "GET_PROVIDER_DETAILS_FAILURE",

    UPDATE_PROVIDER_DETAILS_REQUEST: "UPDATE_PROVIDER_DETAILS_REQUEST",
    UPDATE_PROVIDER_DETAILS_SUCCESS: "UPDATE_PROVIDER_DETAILS_SUCCESS",
    UPDATE_PROVIDER_DETAILS_FAILURE: "UPDATE_PROVIDER_DETAILS_FAILURE",
}  